<template>
  <div class="header">
    <div class="top-head">
      <div class="container clearf">
        <div class="left">
          <span>{{ msg }}</span>
          <span v-if="loginFlag">
            <router-link :to="{ path: '/login' }" id="signUp"
              >请登录</router-link
            >|
            <router-link :to="{ path: '/register' }" id="register"
              >免费注册</router-link
            >
          </span>
          <span v-else>
            <span style="padding: 0 30px;color: #fff;font-size: 14px;">{{
              useName
            }}</span
            >|
            <span
              style="padding: 0 30px;color: #fff;font-size: 14px;cursor: pointer;"
              @click="cancellation"
              >注销</span
            >
          </span>
        </div>
        <div class="right">
          <a href="#" class="app-download">
            APP下载
            <div class="app-qr-code-box">
              <div class="app-qr-code">
                <p>农技APP</p>
                <p>Android下载</p>
                <img src="../assets/app-qr-code-2022.png" alt="" />
              </div>
              <div class="app-qr-code">
                <p>下载农技APP</p>
                <p>iOS下载</p>
                <img src="../assets/ios-qr-code-2022.png" alt="" />
              </div>
            </div>
          </a>
          |
          <a
            href="https://njht.ahnydsj.com"
            target="_blank"
            style="padding-right:0;"
            >后台管理</a
          >
        </div>
      </div>
    </div>
    <div class="main-head">
      <div class="container clearf">
        <div class="logo-box">
          <router-link :to="{ path: '/home' }">
            <img src="../assets/favicon.png" alt="农业技术管理平台" />
            <div class="logo-box__title">
              <span>农业技术管理平台</span>
              <span>解决种植问题，提高产量与品质，助理乡村振兴</span>
            </div>
          </router-link>
        </div>
        <div class="search-box">
          <el-input
            v-model="input"
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            class="search-input"
          ></el-input>
          <el-button class="search-btn" @click="select(input)">搜索</el-button>
        </div>
      </div>
    </div>
    <div class="nav-head">
      <div class="container">
        <ul class="clearf">
          <li
            v-for="(item, index) in nav"
            :key="index"
            :class="currentRoute == item.route ? 'active' : ''"
            @click="goRoute(item.route)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "Hi,欢迎来到农业技术管理平台！",
      loginFlag: true,
      input: "",
      useName: "",
      nav: [
        { title: "网站首页", route: "/home" },
        { title: "农业简讯", route: "/information" },
        { title: "农业百科", route: "/encyclopedias" },
        { title: "农技课堂", route: "/classroom" },
        { title: "农业专家", route: "/expert" },
        { title: "热线问答", route: "/questiontList" },
        // { title: "智慧园区", route: "/smartPark" },
        // { title: "手工艺人", route: "/handicraftsman" },
        { title: "黑茶文化", route: "/teaCulture" }
      ],
      currentRoute: "/home"
    };
  },
  created() {
    let user1 = this.getCookie("user");
    let user2 = sessionStorage.getItem("user");
    if (user1) {
      this.useName = JSON.parse(user1).username;
    }
    if (user2) {
      this.useName = JSON.parse(user2).username;
      this.loginFlag = false;
    }
  },
  methods: {
    //设置cookie
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    },
    //获取cookie
    getCookie: function(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1);
        if (c.indexOf(name) != -1) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    //清除cookie
    clearCookie: function() {
      this.setCookie("user", "", -1);
      this.setCookie("Flag", "", -1);
    },
    goRoute(route) {
      this.$router.push(route);
    },
    select(input) {
      if (input !== "") {
        this.$router.push({
          path: "/seachlist",
          query: { searchContent: this.input }
        });
        sessionStorage.setItem("inputStage", this.input);
        this.input = "";
      }
    },
    cancellation() {
      sessionStorage.setItem("Flag", "");
      sessionStorage.setItem("user", "");
      this.clearCookie();
      this.loginFlag = true;
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.currentRoute = route.path;
        console.log(this.currentRoute);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="less">
@basecolor: #149508;
.container {
  width: 1200px;
  margin: 0 auto;
}
.header {
  .top-head {
    background-color: #333;
    height: 35px;
    line-height: 35px;
    color: @basecolor;
    font-size: 14px;
    color: #fff;
    .left {
      float: left;
      a {
        padding: 0 30px;
        color: #fff;
        font-size: 14px;
      }
    }
    .right {
      float: right;
      a {
        color: #fff;
        font-size: 14px;
        padding: 0 20px;
      }
    }
  }
  .main-head {
    height: 88px;
    line-height: 88px;
    background-color: #fff;
    .logo-box {
      float: left;
      a {
        height: 88px;
        display: flex;
        align-items: center;
        img {
          width: auto;
          height: 64px;
          vertical-align: middle;
        }
      }
      &__title {
        display: flex;
        flex-flow: column;
        span {
          line-height: normal;
          margin-left: 10px;
          &:first-child {
            font-size: 22px;
            color: #57c01b;
            font-weight: 600;
          }
          &:last-child {
            font-size: 12px;
            color: #a0a0a0;
          }
        }
      }
    }
    .search-box {
      float: right;
      width: 350px;
      position: relative;
      .search-btn {
        position: absolute;
        right: 0;
        top: 23px;
        border: 0;
        background-color: @basecolor;
        color: #fff;
        width: 70px;
        height: 43px;
        border-radius: 0;
      }
    }
  }
  .nav-head {
    width: 100%;
    // height: 45px;
    line-height: 45px;
    background: @basecolor;
    li {
      float: left;
      padding: 0 25px;
      height: 100%;
      color: #fff;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: #57c01b;
      }
    }
    .active {
      background-color: #57c01b;
    }
  }
}
.app-download {
  position: relative;
  .app-qr-code-box {
    position: absolute;
    display: -webkit-flex;
    display: flex;
    display: none;
    top: 26px;
    left: -100px;
    justify-content: space-between;
    width: 290px;
    /*height: 120px;*/
    background: #ffffff;
    z-index: 100;
    padding: 6px 10px 10px;
    cursor: default;
    box-shadow: 2px 2px 10px #000;
    .app-qr-code {
      p {
        font-size: 14px;
        line-height: 18px;
        color: #999999;
        text-align: center;
      }
      img {
        margin-top: 4px;
        width: 130px;
        height: 130px;
      }
    }
  }
  &:hover {
    .app-qr-code-box {
      display: block;
      display: -webkit-flex;
      display: flex;
    }
  }
}
// element样式修改
.el-input__inner {
  height: 43px;
  border-radius: 0;
  background: #f6f6f6;
}
.el-input__inner:focus {
  border-color: @basecolor;
}
.el-input__inner:hover {
  border-color: @basecolor;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue